import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { Link } from 'react-router-dom';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const { forgotPassword } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setLoading(true);
    const result = await forgotPassword(email);
    setLoading(false);
    if (result.success) {
      setSent(true);
      setMessage('If an account exists with this email, you will receive a password reset link.');
      setEmail('');
    } else {
      setMessage(result.error);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6" style={{ background: '#f8fafc' }}>
      <div className="w-full max-w-md animate-fade-in">
        {/* Logo */}
        <div className="flex items-center gap-3 mb-8 justify-center">
          <div className="w-10 h-10 rounded-xl flex items-center justify-center"
            style={{ background: 'linear-gradient(135deg, #6366f1, #8b5cf6)' }}>
            <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 20 20">
              <path d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4z" />
            </svg>
          </div>
          <span className="font-bold text-lg text-slate-900">InvoiceFlow</span>
        </div>

        <div className="card p-8">
          {sent ? (
            <div className="text-center">
              <div className="text-5xl mb-4">📬</div>
              <h2 className="text-xl font-bold text-slate-900 mb-2">Check your inbox</h2>
              <p className="text-slate-500 text-sm mb-6">{message}</p>
              <Link to="/login" className="btn-primary inline-block" style={{ textDecoration: 'none' }}>
                Back to login
              </Link>
            </div>
          ) : (
            <>
              <div className="text-center mb-6">
                <div className="text-4xl mb-3">🔑</div>
                <h2 className="text-xl font-bold text-slate-900" data-testid="forgot-password-title">
                  Forgot your password?
                </h2>
                <p className="text-slate-500 text-sm mt-1">
                  Enter your email and we'll send you a reset link
                </p>
              </div>

              {message && !sent && (
                <div className="mb-4 p-3 rounded-xl text-sm" data-testid="forgot-password-message"
                  style={{ background: '#fff1f2', border: '1px solid #fecdd3', color: '#be123c' }}>
                  {message}
                </div>
              )}

              <form onSubmit={handleSubmit} data-testid="forgot-password-form" className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-1.5">Email address</label>
                  <input
                    id="email"
                    type="email"
                    required
                    className="input-modern"
                    data-testid="forgot-password-email-input"
                    placeholder="you@company.com"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                  />
                </div>

                <button type="submit" disabled={loading}
                  className="btn-primary w-full py-2.5"
                  data-testid="forgot-password-submit-button">
                  {loading ? 'Sending...' : 'Send reset link'}
                </button>
              </form>
            </>
          )}
        </div>

        <p className="text-center text-sm text-slate-500 mt-5">
          Remember your password?{' '}
          <Link to="/login" className="font-semibold" style={{ color: '#6366f1' }} data-testid="back-to-login-link">
            Sign in
          </Link>
        </p>
      </div>
    </div>
  );
};

export default ForgotPassword;